/**
 * dfcService.js
 * 
 * Service para comunicação com endpoints do DFC (Demonstração do Fluxo de Caixa).
 */

import api from './api';

export const dfcService = {
  /**
   * Busca DFC completo para um período
   * @param {number} month - Mês (1-12)
   * @param {number} year - Ano (ex: 2024)
   * @param {number|null} accountId - ID da conta financeira (opcional)
   * @returns {Promise<Object>} Dados do DFC
   */
  getDFC: async (month, year, accountId = null) => {
    try {
      const params = { month, year };
      if (accountId) {
        params.accountId = accountId;
      }
      
      const response = await api.get('/api/financial/dfc', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar DFC:', error);
      throw error;
    }
  },

  /**
   * Busca lançamentos de uma categoria no DFC
   */
  getCategoryTransactions: async ({ month, year, categoryId, flowType, accountId = null }) => {
    try {
      const params = { month, year, categoryId, flowType };
      if (accountId) {
        params.accountId = accountId;
      }

      const response = await api.get('/api/financial/dfc/category-transactions', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar transações da categoria DFC:', error);
      throw error;
    }
  }
};

export default dfcService;
